module.exports = __webpack_public_path__ + "img/woo.30a4eecf.png";